(function($) {
$(function(){

    /*****
        AJAX Pages
    *****/
    function setup_ajax_markup() {
        let markup_arr = [];
        markup_arr.push('<div class="ajax-window">');
            markup_arr.push('<span class="ajax-window-top-close"><svg data-icon="close" data-ajax-close viewBox="0 0 19.1 19.1"><use xlink:href="#close"></use></svg></span>');
            markup_arr.push('<div class="ajax-window-inner">');
                markup_arr.push('<div class="ajax-window-content" id="ajax_container"></div>');
                markup_arr.push('<div class="ajax-window-bottom-close padded-wrapper">');
                    markup_arr.push('<div class="ajax-window-bottom-close-inner">');
                        markup_arr.push('<svg data-icon="close" data-ajax-close viewBox="0 0 19.1 19.1"><use xlink:href="#close"></use></svg>');
                    markup_arr.push('</div>');
                markup_arr.push('</div>');
            markup_arr.push('</div>');
        markup_arr.push('</div>');

        const markup = markup_arr.join('');
        $('body').append(markup);
    }

    setup_ajax_markup();

    function load_page(url, type, close_url, close_type) {
        $('.ajax-window').attr('data-type', '');
        $('.ajax-window').attr('data-close-url', '');
        $('.ajax-window').attr('data-close-type', '');
        $('html, body').addClass('no-scroll');
        if (type) {
            $('.ajax-window').attr('data-type', type);
        }
        if (close_url) {
            $('.ajax-window').attr('data-close-url', close_url);
        }
        if (close_type) {
            $('.ajax-window').attr('data-close-type', close_type);
        }
        $("#ajax_container").load(url, function() {
            $(".ajax-window").addClass('show').removeClass('temp-hide');
            sethrefs();
        });
    }

    function replace_page(url, type, close_url, close_type) {
        $(".ajax-window").addClass('temp-hide');
        setTimeout(function(){
            $("#ajax_container").html('');
            load_page(url, type, close_url, close_type);
        }, 310);

    }

    $(document).on('click', '[data-ajax-href]', function(e){
        e.preventDefault();
        const the_url = $(this).attr('data-ajax-href');
        const the_type = $(this).attr('data-ajax-type');
        const close_url = $(this).attr('data-close-url');
        const close_type = $(this).attr('data-close-type');

        if ($(".ajax-window").hasClass('show')) {
            replace_page(the_url, the_type, close_url, close_type);
        } else {
            load_page(the_url, the_type, close_url, close_type);
        }
    });

    // Close ajax window
    function close_ajax_window() {
        if ($('.ajax-window').attr('data-close-url')) {
            const the_url = $('.ajax-window').attr('data-close-url');
            const the_type = $('.ajax-window').attr('data-close-type');
            replace_page(the_url, the_type);
        } else {
            $('html, body').removeClass('no-scroll');
            $(".ajax-window").removeClass('show');

            setTimeout(function(){
                $("#ajax_container").html('');
                $('.ajax-window').attr('data-type', '');
            }, 550);
        }
    }

    $(document).on('click', '[data-ajax-close]', close_ajax_window);

});
})(jQuery);
